import { useEffect } from 'react'

import { loadAwsWafStageIntegration } from '@web-app/lib/awsWafStage'

export function AwsWafStageIntegration() {
  useEffect(() => {
    void loadAwsWafStageIntegration()
  }, [])

  return null
}
